var _g, _g2, _g3, _g4, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconstarts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178,
    height: 26,
    fill: "none",
    viewBox: "0 0 178 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF5",
    d: "M12.173 22.183a1.6 1.6 0 0 1 1.653 0l5.23 3.157c1.212.731 2.707-.355 2.385-1.733l-1.388-5.95a1.6 1.6 0 0 1 .51-1.572l4.623-4.005c1.07-.926.498-2.684-.912-2.803l-6.083-.516a1.6 1.6 0 0 1-1.338-.97l-2.38-5.616c-.552-1.301-2.395-1.301-2.947 0L9.146 7.79a1.6 1.6 0 0 1-1.338.97l-6.083.516c-1.41.12-1.982 1.877-.912 2.803l4.622 4.005a1.6 1.6 0 0 1 .511 1.573l-1.388 5.948c-.322 1.379 1.173 2.465 2.385 1.734l5.23-3.157Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF5",
    d: "M50.173 22.183a1.6 1.6 0 0 1 1.653 0l5.23 3.157c1.212.731 2.707-.355 2.385-1.733l-1.388-5.95a1.6 1.6 0 0 1 .51-1.572l4.623-4.005c1.07-.926.498-2.684-.912-2.803l-6.083-.516a1.6 1.6 0 0 1-1.338-.97l-2.38-5.616c-.552-1.301-2.395-1.301-2.947 0l-2.38 5.616a1.6 1.6 0 0 1-1.338.97l-6.083.516c-1.41.12-1.982 1.877-.912 2.803l4.622 4.005a1.6 1.6 0 0 1 .511 1.573l-1.388 5.948c-.322 1.379 1.173 2.465 2.385 1.734l5.23-3.157Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF5",
    d: "M88.173 22.183a1.6 1.6 0 0 1 1.653 0l5.23 3.157c1.212.731 2.707-.355 2.385-1.733l-1.388-5.95a1.6 1.6 0 0 1 .51-1.572l4.623-4.005c1.07-.926.498-2.684-.912-2.803l-6.083-.516a1.6 1.6 0 0 1-1.338-.97l-2.38-5.616c-.552-1.301-2.395-1.301-2.947 0l-2.38 5.616a1.6 1.6 0 0 1-1.338.97l-6.083.516c-1.41.12-1.982 1.877-.912 2.803l4.623 4.005a1.6 1.6 0 0 1 .51 1.573l-1.388 5.948c-.322 1.379 1.173 2.465 2.385 1.734l5.23-3.157Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF5",
    d: "M126.173 22.183a1.599 1.599 0 0 1 1.653 0l5.23 3.157c1.212.731 2.707-.355 2.385-1.733l-1.388-5.95a1.6 1.6 0 0 1 .511-1.572l4.622-4.005c1.07-.926.498-2.684-.912-2.803l-6.083-.516a1.601 1.601 0 0 1-1.338-.97l-2.38-5.616c-.552-1.301-2.395-1.301-2.947 0l-2.38 5.616c-.232.546-.747.92-1.338.97l-6.083.516c-1.41.12-1.982 1.877-.912 2.803l4.622 4.005a1.6 1.6 0 0 1 .511 1.573l-1.388 5.948c-.322 1.379 1.173 2.465 2.385 1.734l5.23-3.157Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF5",
    d: "M164.173 22.183a1.599 1.599 0 0 1 1.653 0l5.23 3.157c1.212.731 2.707-.355 2.385-1.733l-1.388-5.95a1.6 1.6 0 0 1 .511-1.572l4.622-4.005c1.07-.926.498-2.684-.912-2.803l-6.083-.516a1.601 1.601 0 0 1-1.338-.97l-2.38-5.616c-.552-1.301-2.395-1.301-2.947 0l-2.38 5.616c-.232.546-.747.92-1.338.97l-6.083.516c-1.41.12-1.982 1.877-.912 2.803l4.622 4.005a1.6 1.6 0 0 1 .511 1.573l-1.388 5.948c-.322 1.379 1.173 2.465 2.385 1.734l5.23-3.157Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z",
    transform: "translate(38)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z",
    transform: "translate(76)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z",
    transform: "translate(114)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z",
    transform: "translate(152)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconstarts);
export default __webpack_public_path__ + "static/media/icon starts.44881b134886982d5580ec3e79ac4817.svg";
export { ForwardRef as ReactComponent };